export default function AdminOverview({ ctx }) {
  const { stats } = ctx;
  const data = stats.revenue_30d || [];
  const max = Math.max(1, ...data.map((d) => d.revenue));
  const total30 = stats.revenue_30d_total || 0;
  const fmtDay = (iso) => {
    const d = new Date(iso + "T00:00:00");
    return d.toLocaleDateString("default", { month: "short", day: "numeric" });
  };
  return (
    <div className="mt-10 space-y-4">
      <div data-testid="overview-revenue-chart" className="p-6 rounded-2xl bg-white border border-stone-200">
        <div className="flex items-end justify-between flex-wrap gap-2">
          <div>
            <p className="text-xs tracking-[0.2em] uppercase text-stone-500">Revenue · last 30 days</p>
            <p className="font-serif font-black text-4xl text-[#121212] mt-1">${total30.toFixed(0)}</p>
          </div>
          <p className="text-xs text-stone-400">Daily paid revenue (classes, kits, memberships &amp; Open Studio)</p>
        </div>
        {data.length === 0 || max === 1 ? (
          <p className="text-stone-500 text-sm mt-6">No revenue in the last 30 days yet — paid bookings and orders will chart here automatically.</p>
        ) : (
          <div className="mt-6 flex items-end gap-[3px] h-40">
            {data.map((d) => (
              <div key={d.date} className="group relative flex-1 flex flex-col justify-end h-full" title={`${fmtDay(d.date)} · $${d.revenue.toFixed(2)}`}>
                <div
                  className="w-full bg-[#C6FF33] hover:bg-[#121212] transition-colors rounded-sm"
                  style={{ height: `${Math.max(2, (d.revenue / max) * 100)}%` }}
                />
              </div>
            ))}
          </div>
        )}
        {data.length > 0 && (
          <div className="flex justify-between mt-2 text-[10px] text-stone-400">
            <span>{fmtDay(data[0].date)}</span>
            <span>{fmtDay(data[data.length - 1].date)}</span>
          </div>
        )}
      </div>

      <div className="grid sm:grid-cols-2 gap-4">
        <div className="p-6 rounded-2xl bg-white border border-stone-200">
          <p className="text-xs tracking-[0.2em] uppercase text-stone-500">Users</p>
          <p className="font-serif font-black text-3xl text-[#121212] mt-2">{stats.total_users || 0}</p>
        </div>
        <div className="p-6 rounded-2xl bg-white border border-stone-200">
          <p className="text-xs tracking-[0.2em] uppercase text-stone-500">Active classes</p>
          <p className="font-serif font-black text-3xl text-[#121212] mt-2">{stats.total_classes || 0}</p>
        </div>
      </div>
    </div>
  );
}
